import { CodeBase } from "./_codeBase";

/**
 * カテゴリ選択区分
 */
export class CategorySelectDiv extends CodeBase<CategorySelectDiv>
{
    /** カテゴリ選択区分 "01", "ALL" */
    public static readonly ALL: CategorySelectDiv = new CategorySelectDiv("01", "ALL");
    /** カテゴリ選択区分 "02", "ALL（承認表非表示）" */
    public static readonly ALLAPPROVEINVISIVLE: CategorySelectDiv = new CategorySelectDiv("02", "ALL（承認表非表示）");
    /** カテゴリ選択区分 "03", "カテゴリID" */
    public static readonly CATEGORY: CategorySelectDiv = new CategorySelectDiv("03", "カテゴリID");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): CategorySelectDiv[] {
        return [
            CategorySelectDiv.ALL,
            CategorySelectDiv.ALLAPPROVEINVISIVLE,
            CategorySelectDiv.CATEGORY,
        ];
    }
}
